import { render } from "./LightboxProductBestSeller.vue?vue&type=template&id=7a22c6ca"
import script from "./LightboxProductBestSeller.vue?vue&type=script&lang=js"
export * from "./LightboxProductBestSeller.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__